
define('ldsh!modules/editor/templates/elements/element_box', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '\n';

}
return __p
};});

